export default __webpack_public_path__ + "c350a4bcf37466f49700e39c46f01a52.png";